import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import EventTypeBody from "components/AdministrationComponents/EventType/EventTypeBody";

const EventTypes = () => {
  useEffect(() => {
    document.title = "Administration | Event Type";
  }, []);

  return (
    <main id="app">
      <Header moduleName="administration" />
      <EventTypeBody />
    </main>
  );
};

export default EventTypes;
